<div *ngIf="loadingspinner == true" class="spin"></div>

<fieldset [disabled]="loadingspinner == true" [ngClass]="{'disabled':loadingspinner == true}">

  <section class="wallet-service" *ngIf="token && OptionList">

    <div class="container-fluid">
      <div class="row align-items-center">
        <div class="col-lg-9 col-md-8">
          <div class="wallet-wrapper">
            <div class="wallet-services">
              <div class="Title-bar">
                <h1 class="eze-tille">Courses List</h1>
                <span class="title-underline"></span>
              </div>

              <section class="cat-carousel">
                <owl-carousel-o [options]="customOptions">
                  <ng-container *ngFor="let x of name">
                    <ng-template carouselSlide [Id]="x.Id">
                      <div class="lcatbox cursorIcon">
                        <button class="custom-button" mat-menu-item [matMenuTriggerFor]="dynamicMenu" #menuTrigger="matMenuTrigger"
                                (mouseover)="filterSoucategories(menuTrigger,x.Id)">
                          <img [src]="x?.Icon" alt="Icon">
                          {{ x.Name }}
                        </button>
                        <!--<button mat-menu-item [matMenuTriggerFor]="dynamicMenu"
          class="custom-button" style="color:black;font-size:large;" #menuTrigger="matMenuTrigger"
          (mouseover)="filterSoucategories(menuTrigger,x.Id)">

    <img [src]="x?.Icon" style="height: 50px;width: 50px;" />
  </button>-->


                        <mat-menu #dynamicMenu="matMenu" class="custom-menu" [overlapTrigger]="false" direction="down" yPosition="below">

                          <button mat-menu-item *ngFor="let x of check1" [matMenuTriggerFor]="submenu"
                                  (mouseenter)="filterSubcategories(x.Id,x)" (click)="x.SubCategories.length != 0 ? sendserviceCode(x.Code,1,x.Code,x.Id) :null">
                            {{ x.Name }}
                          </button>

                        </mat-menu>

                        <mat-menu #submenu="matMenu" class="custom-menu" direction="down" yPosition="below">
                          <button mat-menu-item *ngFor="let x of check2" (click)="sendserviceCode(x.Code,1,x.Code,x.Id)">{{ x.Name }}</button>

                        </mat-menu>

                      </div>

                    </ng-template>
                  </ng-container>
                  <a (click)="sendserviceCode(x.Code,1,x.Code,x.Id)" *ngFor="let x of OptionList">
                    <span class="tiltle-txt d-block" style="color:black;font-weight:bold;">{{x.Name}}</span>
                  </a>
                </owl-carousel-o>
              </section>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-4">
          <div class="filter-bar">
            <mat-form-field appearance="outline" class="amount-filter">
              <mat-label>Filter Course By Amount</mat-label>
              <mat-select>
                <mat-option *ngFor="let x of CourseamtList" [value]="x" (click)="getCourseamtList(x)">{{x}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg">
          <ngb-carousel timings="250ms ease-in" [showNavigationArrows]="true"
                        [showNavigationIndicators]="true"
                        [keyboard]="true"
                        [pauseOnHover]="true"
                        [wrap]="true"
                        [activeId]="'sliderOne'">

            <ng-template ngbSlide id="sliderOne">
              <div class="top-content">
                <div class="container-fluid">
                  <div class="row mobile-view">
                    <div class="col justify-content-center m-0 p-0">
                      <img src="../../../../assets/scss/howtopaint.jpg">

                    </div>

                  </div>
                </div>
                <div class="banner_content">

                  <p>HOW TO PAINT- <br /> Portrait Painting </p>

                </div>
              </div>

            </ng-template>
            <ng-template ngbSlide id="sliderTwo">
              <div class="top-content">
                <div class="container-fluid">
                  <div class="row mobile-view">
                    <div class="col justify-content-center m-0 p-0">
                      <img src="../../../../assets/scss/javascript.jpg">

                    </div>

                  </div>
                </div>
                <div class="banner_content">

                  <p></p>

                </div>
              </div>
            </ng-template>
            <ng-template ngbSlide id="sliderThree">
              <div class="top-content">
                <div class="container-fluid">
                  <div class="row mobile-view">
                    <div class="col justify-content-center m-0 p-0">
                      <img src="../../../../assets/scss/sql.jpg">

                    </div>

                  </div>
                </div>
                <div class="banner_content">

                  <p>

                  </p>
                </div>
              </div>

            </ng-template>
            <ng-template ngbSlide id="sliderFour">
              <div class="top-content">
                <div class="container-fluid">
                  <div class="row mobile-view">
                    <div class="col justify-content-center m-0 p-0">
                      <img src="../../../../assets/scss/wordpress.jpeg">

                    </div>

                  </div>
                </div>
                <div class="banner_content">

                  <p> </p>

                </div>
              </div>
            </ng-template>
            <ng-template ngbSlide id="sliderFive">
              <div class="top-content">
                <div class="container-fluid">
                  <div class="row mobile-view">
                    <div class="col justify-content-center m-0 p-0">
                      <img src="../../../../assets/scss/Photography.jpg">

                    </div>

                  </div>
                </div>
                <div class="banner_content">

                  <p>Computerized <br />Photography for <br />Beginners with <br /> DSLR cameras</p>

                </div>
              </div>
            </ng-template>


            <ng-template ngbSlide id="slidersix">
              <div class="top-content">
                <div class="container-fluid">
                  <div class="row mobile-view">
                    <div class="col justify-content-center m-0 p-0">
                      <img src="../../../../assets/scss/Mixin.jpg">

                    </div>

                  </div>
                </div>
                <div class="banner_content">

                  <p>
                    Music Production with <br /> Mixing & Mastering
                  </p>

                </div>
              </div>
            </ng-template>
          </ngb-carousel>
        </div>
      </div>
    </div>
  </section>



  <!--<section class="position-relative" *ngIf="token && OptionList">

    <div class="pay-services container-fluid">

      <div class="col bg-white mx-auto mx-width2">

        <div class="title">
          <h2 class="m-0 p-0 ezze-tille">Pay Services</h2>
          <span class="whitebar">
          </span>
        </div>

        <section class="cat-carousel">
          <owl-carousel-o [options]="customOptions">

            <ng-container *ngFor="let x of OptionList">
              <ng-template carouselSlide [id]="x.Code">
                <div class="lcatbox cursorIcon" (click)="sendserviceCode(x.Code,1,x.Code,x.Id)">


                  <p>{{x.Name}}</p>
                </div>


              </ng-template>
            </ng-container>
          </owl-carousel-o>
        </section>
      </div>

    </div>
  </section>-->

</fieldset>
